import axios from "axios";
import safeLocalStorage from "../utils/localstorage";

const http = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 60000
});

http.interceptors.request.use(
  config => {
    config.headers.Authorization =
      "Bearer " + safeLocalStorage.getItem("arx.token");
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default http;
